// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1WxZM","buttons":"PendingPaymentAlert_buttons__2cbuP"};